import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';
import Select from '../common/form/select';
import SelectAlteracao from '../common/form/selectAlteracao';
import LabelAndCheckbox from '../common/form/labelAndCheckbox';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';

import {
	initFormCotacao
} from './pedidoActions';
import FormatUtils from '../common/formatUtils/FormatUtils';

class CotacaoForm extends Component {

	state = {

	}

    componentWillMount() {

    }

    render() {

		let readOnly = this.props.formularioValues.excluir ? 'readOnly' : '';

		const quantidade = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.quantidade, 2));
		const valorUnitario = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.valor_unitario, 2));
		const percentualIpi = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.percentual_ipi, 2));
		//Difal
		const percentualIcms = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.aliquota_icms_rs, 2)) 
			- parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.percentual_icms, 2));
		const valorDesconto = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.valor_desconto, 2));
		const valorFrete = parseFloat(FormatUtils.formatarValorBanco(this.props.formularioValues.valor_frete, 2));

		let valorSemImposto = parseFloat((quantidade * valorUnitario).toFixed(2));
		let valorIpi = parseFloat(((percentualIpi * valorSemImposto) / 100).toFixed(2));
		let valorIcms = parseFloat(((percentualIcms * valorSemImposto) / 100).toFixed(2));
		let valorComImposto = parseFloat((valorSemImposto + valorIpi + valorIcms).toFixed(2));
		let valorFinal = parseFloat((valorComImposto - valorDesconto + valorFrete).toFixed(2));

		return (
			<div>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							
							<Field
								name='id_solicitacao'
								component={Select}
								label='Solicitação' placeholder='Informe'
								options={this.props.listaItens.map(item => ({ id: item.id_solicitacao, valor: `${item.numero_solicitacao} - ${item.nome_produto}` }))}
								cols='12 12 6 6'
								readOnly={readOnly} />

							<Field
								name='id_fornecedor'
								component={Select}
								label='Fornecedor' placeholder='Informe'
								options={this.props.listaFornecedor}
								cols='12 12 6 6'
								readOnly={readOnly} />

							<Field
								name='quantidade'
								component={LabelAndInputNumber}
								label='Quantidade' placeholder='Informe'
								cols='6 6 6 2'
								readOnly={readOnly}
								mask={2} />

							<Field
								name='valor_unitario'
								component={LabelAndInputNumber}
								label='Valor Unitário (R$)' placeholder='Informe'
								cols='6 6 6 2'
								readOnly={readOnly}
								mask={2} />					

							<Field
								name='percentual_ipi'
								component={LabelAndInputNumber}
								label='Alíquota IPI (%)' placeholder='Informe'
								cols='6 6 3 2'
								readOnly={readOnly}
								mask={2} />
							
							<Field
								name='percentual_icms'
								component={LabelAndInputNumber}
								label='Alíquota ICMS (%)' placeholder='Informe'
								cols='6 6 3 2'
								readOnly={readOnly}
								mask={2} />
							 
							<Field
								name='valor_desconto'
								component={LabelAndInputNumber}
								label='Desconto (R$)' placeholder='Informe'
								cols='6 6 3 2'
								readOnly={readOnly}
								mask={2} />
							
							<Field
								name='valor_frete'
								component={LabelAndInputNumber}
								label='Frete RS (R$)' placeholder='Informe'
								cols='6 6 3 2'
								readOnly={readOnly}
								mask={2} />
						</Row>
						<Row>
							<Table responsive>
								<THead>
									<Tr>
										<Th alignRight>Vlr IPI</Th>
										<Th alignRight>Vlr ICMS</Th>
										<Th alignRight>Vlr Sem Imposto</Th>
										<Th alignRight>Vlr Com Imposto</Th>
										<Th alignRight>Vlr Desconto</Th>
										<Th alignRight>Vlr Frete</Th>
										<Th alignRight>Vlr Final</Th>
									</Tr>
								</THead>
								<TBody>
									<Tr backgroundColor={'#ffffff'} >
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorIpi, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorIcms, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorSemImposto, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorComImposto, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorDesconto, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorFrete, 2)}</Td>
										<Td alignRight small>R$ {FormatUtils.formatarValorTela(valorFinal, 2)}</Td>
									</Tr>
								</TBody>
							</Table>
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.formularioValues.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Cancelar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.initFormCotacao(null)} />
							</Grid>
						</Row>
					</ContentCardFooter>
				</Form>
			</div>
		);
    }


}

CotacaoForm = reduxForm({form: 'pedidoCotacaoForm', destroyOnUnmount: false})(CotacaoForm);
const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	formularioValues: getFormValues('pedidoCotacaoForm')(state),
	registro: state.pedido.registro,
	listaFornecedor: state.fornecedor.listaSelect,
	listaItens: state.pedido.listaItens
});
const mapDispatchToProps = dispatch => bindActionCreators({
	initFormCotacao
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CotacaoForm);
